import { MutationFn, UseQueryFn } from 'shared-ui';

import { UsersQuery } from 'context/query/queryContext/QueryContext.types';
import { PaginatedResponse } from 'core/global.types';

import {
  AddUserBody,
  ChangePasswordBody,
  ChangePasswordWithConfirmationBody,
  ChangePasswordWithTokenResponse,
  CopyUserBody,
  User,
  UserHistory,
  UsersLoginHistory,
} from './users.types';

export const fetchUsers: UseQueryFn<UsersQuery, PaginatedResponse<User>> = () => {
  return {
    endpoint: `/user`,
  };
};

export const updateUserDetails: MutationFn<{ id: string; body: User }, User> = ({ id, body }) => {
  return {
    endpoint: `/user/${id}`,
    method: 'PUT',
    body,
  };
};

export const addUser: MutationFn<AddUserBody, User> = (body) => {
  return {
    endpoint: `/user`,
    method: 'POST',
    body,
  };
};

export const changeUserPassword: MutationFn<{ username: string; body: ChangePasswordBody }, User> = ({
  username,
  body,
}) => {
  return {
    endpoint: `/user/${username}/password/noconfirm`,
    method: 'PUT',
    body,
  };
};

export const changeUserPasswordWithConfirmation: MutationFn<
  { username: string; body: ChangePasswordWithConfirmationBody },
  void
> = ({ username, body }) => {
  return {
    endpoint: `/user/${username}/password`,
    method: 'PUT',
    body,
  };
};

export const fetchLoggedUserDetails: UseQueryFn<void, User> = () => {
  return {
    endpoint: `/me`,
  };
};

export const copyUser: MutationFn<CopyUserBody, User> = ({ id, body }) => {
  return {
    endpoint: `/user/${id}/copy`,
    method: 'POST',
    body,
  };
};

export const fetchUsersLoginHistory: UseQueryFn<void, PaginatedResponse<UsersLoginHistory>> = () => {
  return {
    endpoint: `/user/historia/logowania`,
  };
};

export const fetchUserHistory: UseQueryFn<string, PaginatedResponse<UserHistory>> = (id) => {
  return {
    endpoint: `/user/${id}/historia`,
  };
};

export const changeOwnPasswordWithNoConfirmation: MutationFn<
  { body: ChangePasswordBody; id?: string },
  ChangePasswordWithTokenResponse
> = ({ body }) => {
  return {
    endpoint: `/user/password/noconfirm`,
    method: 'PUT',
    body,
  };
};

export const changeUserPasswordWithNoConfirmation: MutationFn<{ body: ChangePasswordBody; id?: string }, void> = ({
  body,
  id,
}) => {
  return {
    endpoint: `/user/password/${id}/noconfirm`,
    method: 'PUT',
    body,
  };
};

// Re-export types for convenience
export type { ChangePasswordWithTokenResponse } from './users.types';
